import styled from 'styled-components'

const StyledMediaItemContainer = styled.div`
   margin: 0 -0.5rem;
`

export default StyledMediaItemContainer